/*! Theme Name: dhive
Version: 1.1.5
Author: Digital Hyve
template: bb-theme
*/

"use strict";

var zipCodeValid = false;
const thankYouUrl = "/appointment-confirmation/";

(function($) {
	var $locationZipCodeInput = $(".location__zip input");

	if ($locationZipCodeInput.length) {
		$locationZipCodeInput.inputmask("99999");
		if (location.href.indexOf('locations') > 0) {
			$locationZipCodeInput.focus();
		}
	}

	$locationZipCodeInput.keypress(function(e) {
		if ($locationZipCodeInput.val().indexOf("_") === -1) {
			const keyCode = (e.keyCode ? e.keyCode : e.which);
			if (keyCode === 13) {
				jQuery(".location__find").click();
			}
		}
	});

	var data = {},
		servicesInteriorOptions = [],
		servicesInteriorOptionsAdditional = [],
		servicesExteriorOptions = [],
		servicesExteriorOptionsAdditional = [],
		selectNewDate = false,
		currentSQRequest = null,
		byPassWait = false;

	$(document).on("click", ".location__find, .location__find--alt", function() {
		let $zipCodeField = null,
			zipCodeFieldValue = null;

		// Homepage: Hero Find a Location.
		if($(this).hasClass("location__find")) {
			$zipCodeField = $(this).closest("form").find(".location__zip input");

			if(!$zipCodeField.hasClass("wpforms-error")) {
				zipCodeFieldValue = $zipCodeField.val();
			}
		}

		if(zipCodeFieldValue && !zipCodeFieldValue.includes("_")) {
			deleteCookie("fc-location");
			setCookie("fc-location-temp", zipCodeFieldValue, 30);

			window.location = "/locations";
		}

		// Top Bar: Find a Location/Change Location.
		if($(this).hasClass("location__find--alt")) {
			deleteCookie("fc-location");
			deleteCookie("fc-location-temp");
		}
	});

	$(document).on("click", ".location__delete-cookie a", function() {
		deleteCookie("fc-location");
		deleteCookie("fc-location-temp");

		window.location = "/locations";
		return false;
	});

	$(document).on("click", ".location__set-cookie", function() {
		setCookie("fc-location", $(this).data("zipcode"), 30);
	});

	$(".location__country__list li").change(function() {
		$locationZipCodeInput.val("").focus();

		if($(this).hasClass("choice-1")) {
			$locationZipCodeInput.inputmask("99999");
		} else {
			$locationZipCodeInput.inputmask("A9A");
		}
	});

	if($(".date__picker").length) {
		flatpickr(".date__picker", {
			inline: true,
			maxDate: new Date().fp_incr(30),
			minDate: "today",
			onReady: function(selectedDates, dateStr, instance) {
				var dateObj = new Date(),
					month = dateObj.toLocaleString("en-US", {month: "long"}),
					day = dateObj.toLocaleString("en-US", {day: "numeric"});

				$(".step-5").find(".date").empty().text(month + " " + day);
				$(".step-6").find(".date").empty().text(month + " " + day);
				localStorage.setItem("appointment_date", month + " " + day);
				$(".flatpickr-day.today").addClass("selected");
			},
			onChange: function(dateObject, dateString) {
				var dateObj = new Date(dateObject),
					month = dateObj.toLocaleString("en-US", {month: "long"}),
					day = dateObj.toLocaleString("en-US", {day: "numeric"});

				data.ScheduleStartTime = null;
				data.ScheduleEndTime = null;
				data.ScheduleStartDate = dateString;
				data.ScheduleEndDate = dateString;

                $('.switch__to__free__quote').slideUp(250);
				$(".step-3").find(".step__navigation__next button").prop("disabled", true);
				$(".time__picker").removeClass("time__picker--loaded");
				$(".step-3").find(".time__picker").empty();

				if($(this.element).closest(".step").hasClass("step-3") ) {
					$(".step-5 .time, .step-6 .time").empty();
					$(".step-5 .date, .step-6 .date").empty().text(month + " " + day);
				} else {
					$(".step-5 .date, .step-6 .date:not(.date__new)").empty().text(month + " " + day);
				}

				localStorage.setItem("appointment_date", month + " " + day);
				
				if(currentSQRequest) {
					currentSQRequest.abort();
				}

				$(".flatpickr-calendar").addClass("wait");

                if ($(window).width() < 767) {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $('.pickers').offset().top - $(".site__header").height() - 10
                    }, 500);
                }

				sq(data);
			}
		});
	}

	// Step 1.
	// $(document).on("keyup", ".step-1 #wpforms-4129-field_8", function() {
	// 	var locationInputValue = $(this).val().replace(/_/g, ""),
	// 		locationInputCountryValue = $("#wpforms-662-field_13").find("input:checked").val(),
	// 		locationInputValueLengthCheck = locationInputCountryValue.length;

	// 	if(locationInputCountryValue === "Canada") {
	// 		locationInputValueLengthCheck = 3;
	// 	} else if(locationInputCountryValue === "USA") {
	// 		locationInputValueLengthCheck = 5;
	// 	}

	// 	if(!locationInputValue.includes("_") && locationInputValue.length === locationInputValueLengthCheck) {
	// 		$(".step-1").find(".step__navigation__next button").prop("disabled", false);
	// 		data.ZipCode = locationInputValue;

	// 		$("#wpforms-000-field_11-postal").val(data.ZipCode);
	// 	} else {
	// 		$(".step-1").find(".step__navigation__next button").prop("disabled", true);
	// 	}
	// });

	// $(document).on("change", ".step-1 input[type=radio]", function() {
	// 	$(".step-1 #wpforms-662-field_8").keyup();
	// });


	// Step 2.
	$(document).on("keyup blur change", ".step-2 #wpforms-000-field_8, .step-2 #wpforms-000-field_8-last, .step-2 #wpforms-000-field_10, .step-2 #wpforms-000-field_15, .step-2 #wpforms-000-field_11, .step-2 #wpforms-000-field_11-city, .step-2 #wpforms-000-field_11-state, .step-2 #wpforms-000-field_11-postal, .step-2 #wpforms-803-field_26_1", function() {
		var firstNameValid = false,
			lastNameValid = false,
			emailAddressValid = false,
			phoneNumberValid = false,
			addressValid = false,
			cityValid = false,
			stateValid = false,
			zipCodeValid = false,
			termsValid = false;

		if($("#wpforms-000-field_8").val().length >= 2) {
			firstNameValid = true;
			data.FirstName = $("#wpforms-000-field_8").val();
		} else {
			firstNameValid = false;
		}

		if($("#wpforms-000-field_8-last").val().length >= 2) {
			lastNameValid = true;
			data.LastName = $("#wpforms-000-field_8-last").val();
		} else {
			lastNameValid = false;
		}

		if((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test($("#wpforms-000-field_10").val())) {
			emailAddressValid = true;
			data.Email = $("#wpforms-000-field_10").val();
		} else {
			emailAddressValid = false;
		}

		if($("#wpforms-000-field_15").val().replace(/_|-|\(|\)| /g, "").length === 10) {
			phoneNumberValid = true;
			data.PhoneNumber = $("#wpforms-000-field_15").val();
		} else {
			phoneNumberValid = false;
		}

		if($("#wpforms-000-field_11").val().length >= 3) {
			addressValid = true;
		} else {
			addressValid = false;
		}

		if($("#wpforms-000-field_11-city").val().length >= 3) {
			cityValid = true;
		} else {
			cityValid = false;
		}

		if($("#wpforms-000-field_11-state").val().length >= 2) {
			stateValid = true;
		} else {
			stateValid = false;
		}

		if($("#wpforms-000-field_11-country").val() == "US" || $("#wpforms-000-field_11-country").val() === "USA") {
			if($("#wpforms-000-field_11-postal").val().replace(/_/g, "").length >= 5) {
				zipCodeValid = true;
				data.ZipCode = $("#wpforms-000-field_11-postal").val();
			} else {
				zipCodeValid = false;
			}
		} else {
			if($("#wpforms-000-field_11-postal").val().replace(/_/g, "").length >= 3) {
				zipCodeValid = true;
				data.ZipCode = $("#wpforms-000-field_11-postal").val();
			} else {
				zipCodeValid = false;
			}
		}

		if ($(".step-2 #wpforms-803-field_26_1").prop("checked")) {
			termsValid = true;
		} else {
			termsValid = false;
		}

		if(firstNameValid && lastNameValid && emailAddressValid && phoneNumberValid && addressValid && cityValid && stateValid && zipCodeValid && termsValid) {
			$(".step-2").find(".step__navigation__next button").prop("disabled", false);
			$(".step-5").find(".name").empty().text($("#wpforms-000-field_8").val() + " " + $("#wpforms-000-field_8-last").val());
			$(".step-5").find(".phone__number").empty().text($("#wpforms-000-field_15").val());
			$(".step-5").find(".email__address").empty().text($("#wpforms-000-field_10").val());
			$(".step-5").find(".address").empty().text($("#wpforms-000-field_11").val());
			$(".step-5").find(".city").empty().text($("#wpforms-000-field_11-city").val());
			$(".step-5").find(".state").empty().text($("#wpforms-000-field_11-state").val());
			$(".step-5").find(".zip__code").empty().text($("#wpforms-000-field_11-postal").val());

			data.Address = $("#wpforms-000-field_11").val();
			data.City = $("#wpforms-000-field_11-city").val();
			data.State = $("#wpforms-000-field_11-state").val();
			data.Url = window.location.hostname + window.location.pathname.replace("locations/", "");
			data.Country = $("#wpforms-000-field_11-country").val();
		} else {
			$(".step-2").find(".step__navigation__next button").prop("disabled", true);
		}
	});

	$(document).on("keypress", function(e) {
		if($(e.target.form).closest(".step") && e.which === 13 && $(e.target.form).hasClass("wpforms-form")) {
			$(".step--active").find(".step__navigation__next .fl-button").trigger("click");
			return false;
		}
	});


	// Step 3.
	$(document).on("click", ".time__picker__item", function() {
		data.ScheduleStartTime = $(this).data("start-time");
		data.ScheduleEndTime = $(this).data("end-time");
		data.StaffId = $(this).data("staff-id");
		data.UserProfileId = $(this).data("user-profile-id");
		data.OwnerName = $(this).data("owner-name");
		data.TerritoryId = $(this).data("territory-id");
		data.FranchiseeOwnerEmail = $(this).data("owner-email");

		if($(this).hasClass("time__picker__item--selected")) {
			$(this).removeClass("time__picker__item--selected");
			$(".step-3").find(".step__navigation__next button").prop("disabled", true);
			$(".step-6").find(".step__navigation__next button").prop("disabled", true);
		} else {
			$(".time__picker .time__picker__item--selected").removeClass("time__picker__item--selected");
			$(this).addClass("time__picker__item--selected");
			$(".step-3").find(".step__navigation__next button").prop("disabled", false);
			$(".step-5 .time").empty().text($(this).text());

			localStorage.setItem("appointment_time", $(this).text());

			if($(this).closest(".step").hasClass("step-3")) {
				$(".step-6 .time").empty().text($(this).text());
			} else {
				$(".step-6").find(".step__navigation__next button").prop("disabled", false);
				$(".step-6 .time:not(.time__new)").empty().text($(this).text());
				// $(".step-3").find(".flatpickr-day.today").trigger("click");
			}
		}
	});


	// Step 4.
	$(document).on("click", ".service__item", function() {
		var servicesInteriorOptionsIndex = null,
			servicesInteriorOptionsAdditionalIndex = null,
			servicesExteriorOptionsIndex = null,
			servicesExteriorOptionsAdditionalIndex = null,
			interiorOptionsString = null,
			exteriorOptionsString = null;

		if($(this).closest("ol").hasClass("services__interior__options")) {
			if($(this).hasClass("service__item--selected")) {
				servicesInteriorOptionsIndex = servicesInteriorOptions.indexOf("Interior: " + $(this).text());
				servicesInteriorOptions.splice(servicesInteriorOptionsIndex, 1);
				$(this).removeClass("service__item--selected");
			} else {
				servicesInteriorOptions = [];
				$(".services__interior__options .service__item--selected").removeClass("service__item--selected");
				$(this).addClass("service__item--selected");
				servicesInteriorOptions.push("Interior: " + $(this).text());
			}
		}

		if($(this).closest("ol").hasClass("services__interior__options__additional")) {
			if($(this).hasClass("service__item--selected")) {
				servicesInteriorOptionsAdditionalIndex = servicesInteriorOptionsAdditional.indexOf("Interior: " + $(this).text());
				servicesInteriorOptionsAdditional.splice(servicesInteriorOptionsAdditionalIndex, 1);
				$(this).removeClass("service__item--selected");
			} else {
				$(this).addClass("service__item--selected");
				servicesInteriorOptionsAdditional.push("Interior: " + $(this).text());
			}
		}

		if($(this).closest("ol").hasClass("services__exterior__options")) {
			if($(this).hasClass("service__item--selected")) {
				servicesExteriorOptionsIndex = servicesExteriorOptions.indexOf("Exterior: " + $(this).text());
				servicesExteriorOptions.splice(servicesExteriorOptionsIndex, 1);
				$(this).removeClass("service__item--selected");
			} else {
				servicesExteriorOptions = [];
				$(".services__exterior__options .service__item--selected").removeClass("service__item--selected");
				$(this).addClass("service__item--selected");
				servicesExteriorOptions.push("Exterior: " + $(this).text());
			}
		}

		if($(this).closest("ol").hasClass("services__exterior__options__additional")) {
			if($(this).hasClass("service__item--selected")) {
				servicesExteriorOptionsAdditionalIndex = servicesExteriorOptionsAdditional.indexOf("Exterior: " + $(this).text());
				servicesExteriorOptionsAdditional.splice(servicesExteriorOptionsAdditionalIndex, 1);
				$(this).removeClass("service__item--selected");
			} else {
				$(this).addClass("service__item--selected");
				servicesExteriorOptionsAdditional.push("Exterior: " + $(this).text());
			}
		}

		if(servicesInteriorOptions.length > 0 || servicesInteriorOptionsAdditional.length > 0 || servicesExteriorOptions.length > 0 || servicesExteriorOptionsAdditional.length > 0) {
			$(".step-4").find(".step__navigation__next button").prop("disabled", false);

			interiorOptionsString = $(".services__interior__options .service__item--selected, .services__interior__options__additional .service__item--selected").map(function() {
				return $(this).text();
			}).get().join(", ");
			$(".step-5").find(".services__interior__list").empty().text(interiorOptionsString);

			exteriorOptionsString = $(".services__exterior__options .service__item--selected, .services__exterior__options__additional .service__item--selected").map(function() {
				return $(this).text();
			}).get().join(", ");
			$(".step-5").find(".services__exterior__list").empty().text(exteriorOptionsString);

			if(interiorOptionsString.length !== 0) {
				$(".services__interior__header, .services__interior__list").show();
			} else {
				$(".services__interior__header, .services__interior__list").hide();
			}

			if(exteriorOptionsString.length !== 0) {
				$(".services__exterior__header, .services__exterior__list").show();
			} else {
				$(".services__exterior__header, .services__exterior__list").hide();
			}
		} else {
			$(".step-4").find(".step__navigation__next button").prop("disabled", true);
		}
	});


	// Navigation.
	$(document).on("click", ".step__navigation__back .fl-button--alt, .step__navigation__next .fl-button, .step__navigation__submit .fl-button", function() {
		var stepValue = $(this).data("step");

		if($(this).data("step") === 2) {
			trackFormStep("1");
			$(".flatpickr-calendar").removeClass("wait");
			$(".flatpickr-day.selected").removeClass("selected");
			$(".time__picker.time__picker--loaded").removeClass("time__picker--loaded");
			$(".step-3").find(".time__picker").empty();
			//$(".step-3").find(".time__picker").empty().append("<li>No time slots available.<br>Please select another day.</li>");
			$(".step-3").find(".step__navigation__next button").prop("disabled", true);

			data.ScheduleStartDate = null;
			data.ScheduleEndDate = null;
			data.ScheduleStartTime = null;
			data.ScheduleEndTime = null;

			if(currentSQRequest) {
				currentSQRequest.abort();
			}
		}

		if($(this).data("step") === 3) {
			trackFormStep("2");
			if(!byPassWait) {
				$(".flatpickr-calendar").addClass("wait");
			}
			$("#wpforms-803-field_8").val($("#wpforms-000-field_8").val());
			$("#wpforms-803-field_8-last").val($("#wpforms-000-field_8-last").val());
			$("#wpforms-803-field_10").val($("#wpforms-000-field_10").val());
			$("#wpforms-803-field_15").val($("#wpforms-000-field_15").val());
			$("#wpforms-803-field_11").val($("#wpforms-000-field_11").val());
			$("#wpforms-803-field_11-city").val($("#wpforms-000-field_11-city").val());
			$("#wpforms-803-field_11-state").val($("#wpforms-000-field_11-state").val());
			$("#wpforms-803-field_11-postal").val($("#wpforms-000-field_11-postal").val());
			$("#wpforms-803-field_11-country option[value='" + $("#wpforms-000-field_11-country").val() + "']").prop("selected", true);
			$("#wpforms-803-field_2 option[value='Yes, I am a potential new customer']").prop("selected", true);
			$("#wpforms-803-field_19").val("Please get in touch.");
			$('#wpforms-803-field_26_1').prop('checked', 'checked');

			byPassWait = true;
		}

		$(".step.step--active").removeClass("step--active");
		$(".step-" + stepValue).addClass("step--active");

		$([document.documentElement, document.body]).animate({
			scrollTop: $(".column.column__right").offset().top - $("header").height() - 10
		}, 500);

		if($(this).hasClass("fl-button") && $(this).data("step") === 3) {
			getFranchiseeID(data.ZipCode);
		}

		if($(this).data("step") === 3 && selectNewDate) {
			$(".step-3").find(".flatpickr-day.today").trigger("click");
		}

		if($(this).data("step") === 4) {
			trackFormStep("3");
			const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

			let date = null,
			month = null,
				day = null;

			if ($(".flatpickr-day.selected").length) {
				date = new Date($($(".flatpickr-day.selected")[0]).attr("aria-label"));
			} else {
				date = new Date($($(".flatpickr-day.today")[0]).attr("aria-label"));
			}

			month = monthNames[date.getMonth()];
			day = date.getDate();

			$(".step-5 .date, .step-6 .date").empty().text(month + " " + day);
		}

		if($(this).data("step") === 5) {
			trackFormStep("3.5");
		}
	});

	$(document).on("click", ".step__navigation__submit", function() {
		trackFormStep("4");
		data.Type = "SaveCustomerFormAnswerConnect";
		data.ProjectType = String([servicesInteriorOptions, servicesInteriorOptionsAdditional, servicesExteriorOptions, servicesExteriorOptionsAdditional].flat());

		$(".step-6").find(".column__wait").removeClass("column__full--active");
		$(".step-6").find(".column__confirmed").removeClass("column__full--active");
		$(".step-6").find(".column__loading").addClass("column__full--active");

		sq(data);
	});

	$(document).on("click", ".switch__to__free__quote", function() {
		var checkSubmission = null;

		$(".splash__loader").addClass("splash__loader--active");

		$([document.documentElement, document.body]).animate({
			scrollTop: $(".splash__loader").offset().top - $("header").height() + 2
		}, 500);

		$(".schedule__in__home__quote__appointment").hide(0 ,function() {
			$(this).remove();
		});

		trackFormStep("skipped-calendar");

		$(".free__quote").show();
		$(".free__quote").addClass("free__quote--hidden");
		$("#wpforms-form-803").submit();

		checkSubmission = setInterval(function() {
			if($("#wpforms-803").find(".wpforms-confirmation-container-full").length) {
				clearInterval(checkSubmission);
				location.href = thankYouUrl;
			}
		}, 100);
	});

	// Get franchisee ID.
	function getFranchiseeID(zipCode) {
		$.ajax({
			url: "/wp-admin/admin-ajax.php",
			type: "POST",
			data: {
				"locationID": readCookie("fc-location"),
				"action": "franchiseeID_content_AJAX",
			}, success: function(response) {
				response = response.split("/")[0].trim();
				data.FranchiseeNumber = response;
				getLatitudeLongitudeFromZipCode(data.ZipCode);
			},
			// error: function(response) {
			// 	// console.log("Bad or non-existing franchise ID.", response);
			// }
		});
	}

	// Get latitude & longitude from zip code.
	function getLatitudeLongitudeFromZipCode(zipCode) {
		$.ajax({
			url : "https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:" + zipCode + "&sensor=false&key=AIzaSyCAw0iHG5sCAZgu1ROirUPHgogW2JtVvok",
			method: "POST",
			success:function(response) {
				var today = new Date();

				// data.SourceLatitude = response.results[0].geometry.location.lat;
				// data.SourceLongitude = response.results[0].geometry.location.lng;
				data.SourceLatitude = 0;
				data.SourceLongitude = 0;
				data.Type = "GetFranchiseeDetailByZipCode";
				data.ScheduleStartDate = today.toISOString().split("T")[0];
				data.ScheduleEndDate = today.toISOString().split("T")[0];

				sq(data);
			},
			error: function(reponse) {
				// console.log("Bad or non-existing zip code", response);
			}
		});
	}

	// Handle sq.
	function sq(data) {
		currentSQRequest = $.ajax({
			type: "GET",
			url: "/wp-content/themes/dhive/sq.php",
			contentType: "application/json",
			data: data,
			success: function(response) {
				$(".flatpickr-calendar").removeClass("wait");

				var responseData = JSON.parse(response),
					availableHours;

				if(data.Type === "GetFranchiseeDetailByZipCode") {
					if(responseData === "No data available.") {
						$(".step-3, .step-6").find(".time__picker").empty().append("<li>No time slots available.<br>Please select another day.</li>");
						$('.switch__to__free__quote').slideDown(250);
						$(".time__picker").addClass("time__picker--loaded");

						return;
					} else if (responseData[0]["SchedulesList"]) {
						availableHours = responseData[0]["SchedulesList"];
					}

					$(".step-3, .step-6").find(".time__picker").empty();

					for(var i = 0; i < responseData[0]["SchedulesList"].length; i++) {
						$(".step-3, .step-6").find(".time__picker").append('<li class="time__picker__item" data-start-time="' + availableHours[i]["StartTime"] + '" data-end-time="' + availableHours[i]["EndTime"] + '" data-staff-id="' + availableHours[i]["StaffId"] + '" data-owner-name="' + availableHours[i]["Name"] + '" data-user-profile-id="' + availableHours[i]["UserProfileID"] + '" data-territory-id="' + responseData[0]["TerritoryId"] + '" data-owner-email="' + responseData[0]["Email"] + '">' + new Date(data.ScheduleStartDate + " " + availableHours[i]["StartTime"]).toLocaleTimeString("en-US", {hour: "numeric", minute: "numeric", hour12: true}) + '</li>')
					}

					$(".time__picker").addClass("time__picker--loaded");
				} else if(data.Type === "SaveCustomerFormAnswerConnect") {
					if(response.includes("Appointment Scheduled Successfully")) {
						//sessionStorage.removeItem("fc-location");
						// $(".step-6").find(".column__loading").removeClass("column__full--active");
						// $(".step-6").find(".column__wait").removeClass("column__full--active");
						// $(".step-6").find(".column__confirmed").addClass("column__full--active");
						
						let redirectUrl = thankYouUrl;

						if (typeof gaLocationSlug !== 'undefined' && gaLocationSlug !== null && gaLocationSlug !== '') {
							redirectUrl += '?location=' + gaLocationSlug;
						}

						location.href = redirectUrl;

					} else if(response.includes("Error occur while saving") || response.includes("This slot is already taken")) {
						data.Type = "GetFranchiseeDetailByZipCode";
						$(".step-6").find(".column__loading").removeClass("column__full--active");
						$(".step-6").find(".column__wait").addClass("column__full--active");
						$(".step-6").find(".column__confirmed").removeClass("column__full--active");
						$(".step-6").find(".flatpickr-day.today").trigger("click");
						selectNewDate = true;
					}
				}
			},
			error: function(reponse) {
				// console.log("Error", response);
			}
		});
	}

	setTimeout(function() {
		// $("#wpforms-000-field_11-country option[value='" + $("#wpforms-000-field_11-country").data("value") + "']").prop("selected", true);
		$("#wpforms-000-field_11-country option[value='US']").prop("selected", true);
		$("#wpforms-000-field_11-country option[value='USA']").prop("selected", true);
		$("#wpforms-000-field_15").inputmask();
		$("#wpforms-803-field_11-country option[value='US']").prop("selected", true);
		$("#wpforms-803-field_11-country option[value='USA']").prop("selected", true);
		$("#wpforms-803-field_15").inputmask();

		function setZipCodeMask() {
			const selectedValue = $("#wpforms-000-field_11-country").val(),
				zipField = $("#wpforms-000-field_11-postal");


			if(selectedValue === "US" || selectedValue === "USA") {
				zipField.inputmask("99999");
			} else {
				zipField.inputmask("A9A");
			}
		}

		function setZipCodeMaskSimple() {
			const selectedValue = $("#wpforms-803-field_11-country").val(),
				zipField = $("#wpforms-803-field_11-postal");

			if(selectedValue === "US" || selectedValue === "USA") {
				zipField.inputmask("99999");
			} else {
				zipField.inputmask("A9A");
			}
		}

		setZipCodeMask();
		setZipCodeMaskSimple();

		$("#wpforms-803-field_11-country").change(function() {
			$("#wpforms-803-field_11-postal").val("");

			setZipCodeMaskSimple();
		});

		$("#wpforms-000-field_11-country").change(function() {
			$("#wpforms-000-field_11-postal").val("");
			$(".step-2 #wpforms-000-field_11-postal").trigger("keyup");

			zipCodeValid = false;

			setZipCodeMask();
		});
	}, 50);
})(jQuery);


function trackFormStep(stepNumber) {
	console.log("Form Step: ", stepNumber);
	window.dataLayer.push({
		"event": "SQFormSteps",
		"formStep": stepNumber,
		"SQBooking": 1
	});
}

// Set cookie.
function setCookie(name, value, expiration) {
	let date = new Date();

	// Expiration in days.
	date.setTime(date.getTime() + (expiration * 24 * 60 * 60 * 1000));

	const expires = "expires=" + date.toUTCString();
	document.cookie = name + "=" + value + "; " + expires + "; path=/";
}

// Delete cookie.
function deleteCookie(cookie) {
	setCookie(cookie, "", -1);
}

// Read cookie.
function readCookie(cookie) {
	let c = document.cookie.match(`(?:(?:^|.*; *)${cookie} *= *([^;]*).*$)|^.*$`)[1]
	if (c) return decodeURIComponent(c);
}

function naviTrackSubmission() {
	try {
		console.log("Checking Cookie");
		if (readCookie("fc-location")) {
			if (allowedNaviLocations.includes(parseInt(readCookie("fc-location")))) {
				MGX.push({
					AccessKey: "C761685E449A",
					Label: "Conversion",
					Info: "Quote",
					OrderId: null,
					OrderTotal: null
				});
				console.log("Conversion!");
			}
		}
	}
	catch (err) {
		console.log(err);
	}
}

jQuery(document).ready(function() {
	if (!readCookie("fc-location")) {
		const ownAFranchise = `		
			<div class="fl-icon-wrap own-franchise-head"> &nbsp; 
			<span class="fl-icon"><a href="https://freshcoatfranchise.com/" onclick="pushEvent('own_franchise_header_click');" target="_blank" aria-hidden="true" tabindex="-1"><i class="fas fa-briefcase"></i></a></span>
			<div class="fl-icon-text">
			<a href="https://freshcoatfranchise.com/" onclick="pushEvent('own_franchise_header_click');" target="_blank" class="fl-icon-text-link fl-icon-text-wrap">Own a Franchise</a>
			</div></div>
			<style>@media (max-width: 680px) { .own-franchise-head { display: none !important; } }
			`;
		jQuery(".site__top-bar__column-left .fl-module-content").append(ownAFranchise);
	}
});

function pushEvent(eventName) {
	window.dataLayer.push({
		"event": eventName,
	});
	return false;
}

jQuery(document).ready(function() {
    jQuery('a[target="_blank"]').each(function () {
		const linkText = jQuery(this).text().replace(/(\r\n|\n|\r)/gm, "").trim();
        jQuery(this).attr('aria-label', linkText + ' (opens in new window)');
    });
});